module.exports = __webpack_public_path__ + "img/wanglianzhong.a23ab9c1.jpg";